import { render, staticRenderFns } from "./statisticsCoupon.vue?vue&type=template&id=42740a94&scoped=true"
import script from "./statisticsCoupon.vue?vue&type=script&lang=js"
export * from "./statisticsCoupon.vue?vue&type=script&lang=js"
import style0 from "./statisticsCoupon.vue?vue&type=style&index=0&id=42740a94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42740a94",
  null
  
)

export default component.exports